import { authedFetch } from "#utils/apiFetch"

const PORTFOLIO_UPDATED_ROUTE = "/api/notifications/portfolio-updated"

/**
 * Tells the server a teacher just changed a student's portfolio so it can push
 * a mobile notification. Fire-and-forget: the portfolio itself is already saved
 * to Firestore by the time this runs, so a failure here is logged and nothing
 * more — never surfaced to the teacher.
 *
 * Only ids go over the wire. The server resolves the project name from the
 * portfolio doc and the teacher's name from `users/{actorUserId}`.
 */
export const notifyPortfolioUpdated = async ({
  studentId,
  projectId,
  actorUserId,
}: {
  studentId: string
  projectId: string
  actorUserId: string
}): Promise<void> => {
  try {
    const response = await authedFetch(PORTFOLIO_UPDATED_ROUTE, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ studentId, projectId, actorUserId }),
    })

    if (!response.ok) {
      console.warn(
        `⚠️ portfolio-updated notification returned ${response.status} for student ${studentId} project ${projectId}`
      )
    }
  } catch (error) {
    console.warn(
      `⚠️ portfolio-updated notification failed for student ${studentId} project ${projectId}:`,
      error
    )
  }
}
